import {
  parseNetlifyResponseBody,
  postToNetlifyFunction,
  readNetlifyErrorMessage,
} from './netlifyClient';

export type NotificationTestChannel = 'email' | 'in_app';

export type NotificationAdminTestPayload =
  | {
      channel: 'email';
      to: string;
      subject?: string;
      text: string;
    }
  | {
      channel: 'in_app';
      subject?: string;
      text: string;
    };

export interface NotificationAdminTestResponse {
  dryRun: boolean;
  channel: NotificationTestChannel;
  recipient: string;
  actorId: number;
  success: boolean;
  detail?: string;
}

class NotificationAdminService {
  private ensureResponseExists(response: Response | null): Response {
    if (!response) {
      throw new Error('Session invalide: token manquant.');
    }

    return response;
  }

  private async postTestNotification(
    payload: NotificationAdminTestPayload
  ): Promise<Response | null> {
    return postToNetlifyFunction({
      functionName: 'notifications-admin-test',
      payload,
      missingTokenStrategy: 'throw',
    });
  }

  private async parseSuccessResponse(response: Response): Promise<NotificationAdminTestResponse> {
    const parsedBody = await parseNetlifyResponseBody(response);
    return parsedBody as NotificationAdminTestResponse;
  }

  private async ensureSuccessfulResponse(response: Response): Promise<void> {
    if (response.ok) {
      return;
    }

    const errorMessage = await readNetlifyErrorMessage(
      response,
      `Echec test notification (${response.status})`
    );
    throw new Error(errorMessage);
  }

  public async sendTest(payload: NotificationAdminTestPayload): Promise<NotificationAdminTestResponse> {
    const response = this.ensureResponseExists(await this.postTestNotification(payload));

    await this.ensureSuccessfulResponse(response);
    return this.parseSuccessResponse(response);
  }
}

export const notificationAdminService = new NotificationAdminService();
